import { createStyles, makeStyles } from '@material-ui/core';

const ReAttemptStyles = makeStyles(() =>
  createStyles({
    reAttemptHeading: {
      margin: '1.875rem 0rem',
    },
    reAttemptText: {
      margin: '1.875rem 0rem',
    },
  }),
);

export default ReAttemptStyles;
